import { z } from 'zod';

/** Closed sets shared by the database, the API and the web app (data model §1). */

export const USER_ROLES = ['admin', 'manager', 'member'] as const;
export const userRoleSchema = z.enum(USER_ROLES);
export type UserRole = z.infer<typeof userRoleSchema>;

export const USER_STATUSES = ['active', 'deactivated'] as const;
export const userStatusSchema = z.enum(USER_STATUSES);
export type UserStatus = z.infer<typeof userStatusSchema>;

/** ADR-0014: the phones the Tasklist app runs on (D46). */
export const PHONE_PLATFORMS = ['ios', 'android'] as const;
export const phonePlatformSchema = z.enum(PHONE_PLATFORMS);
export type PhonePlatform = z.infer<typeof phonePlatformSchema>;

/** ADR-0014: a session belongs to the web app (cookie) or to a phone (bearer token). */
export const SESSION_CLIENTS = ['web', 'phone'] as const;
export type SessionClient = (typeof SESSION_CLIENTS)[number];

export const LABEL_KINDS = ['status', 'priority'] as const;
export const labelKindSchema = z.enum(LABEL_KINDS);
export type LabelKind = z.infer<typeof labelKindSchema>;

/** Status labels map to a category; dashboards and "done" logic use the category, not the name. */
export const LABEL_CATEGORIES = ['not_started', 'in_progress', 'stuck', 'done'] as const;
export const labelCategorySchema = z.enum(LABEL_CATEGORIES);
export type LabelCategory = z.infer<typeof labelCategorySchema>;

export const PROJECT_HEALTH = ['on_track', 'at_risk', 'done'] as const;
export const projectHealthSchema = z.enum(PROJECT_HEALTH);
export type ProjectHealth = z.infer<typeof projectHealthSchema>;

export const NOTIFICATION_TYPES = [
  'assigned',
  'mentioned',
  'comment',
  'due_soon',
  'overdue',
] as const;
export const notificationTypeSchema = z.enum(NOTIFICATION_TYPES);
export type NotificationType = z.infer<typeof notificationTypeSchema>;

/** `push` (D46, ADR-0015): to the phones the person is signed in on with the Tasklist app. */
export const NOTIFICATION_CHANNELS = ['in_app', 'email', 'push'] as const;
export const notificationChannelSchema = z.enum(NOTIFICATION_CHANNELS);
export type NotificationChannel = z.infer<typeof notificationChannelSchema>;

export const TRASH_ENTITY_TYPES = ['project', 'group', 'task', 'file'] as const;
export const trashEntityTypeSchema = z.enum(TRASH_ENTITY_TYPES);
export type TrashEntityType = z.infer<typeof trashEntityTypeSchema>;
